window.dataLayer = window.dataLayer || [];
function gtag() { dataLayer.push(arguments); }
gtag('js', new Date());
gtag('config', 'G-WWD5WTEHY1');


window.googleanalyticsInterop = {

    setUserRoleForGTag: async (role) =>
    {
        gtag('set', 'user_properties', {
            'role': role
        });
    }

}



